export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20fashion%20accessories%20sneakers%20and%20textiles%20floating%20in%20soft%20gradient%20space%2C%20warm%20peach%20and%20cream%20tones%2C%20ethereal%20dreamy%20atmosphere%2C%20editorial%20fashion%20concept%20photography%2C%20gentle%20diffused%20lighting%2C%20minimal%20floating%20arrangement%20with%20negative%20space%2C%20sophisticated%20contemporary%20aesthetic&width=1800&height=1000&seq=hero-acbuy-unique-v2&orientation=landscape"
          alt="ACBuySpreadsheet fashion shopping flat lay"
          title="ACBuySpreadsheet — Buy from China Smarter Cheaper Safer"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-black/10"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-xl">
          <h1 className="text-white font-heading text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-5">
            <span className="block">ACBuy</span>
            <span className="block">Spreadsheet</span>
            <span className="block">Guide</span>
          </h1>
          <p className="text-white/80 text-base md:text-lg mb-8 max-w-md font-body leading-relaxed">
            The ultimate China shopping spreadsheet system. Buy smarter, cheaper, and faster with the method trusted by thousands worldwide.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-7 py-3.5 rounded-full text-base font-semibold transition-all cursor-pointer whitespace-nowrap font-label"
            >
              acbuy spreadsheet
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-white border border-white/30 px-7 py-3.5 rounded-full text-base font-semibold transition-all cursor-pointer whitespace-nowrap font-label"
            >
              buy it now
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-5 mt-8">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-white/70 text-sm"></i>
              <span className="text-white/70 text-xs font-label">Secure Guide</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-flashlight-line text-white/70 text-sm"></i>
              <span className="text-white/70 text-xs font-label">Fast Setup</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-verified-badge-line text-white/70 text-sm"></i>
              <span className="text-white/70 text-xs font-label">Verified System</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}